import axios, { AxiosRequestConfig } from "axios";
import { getAccessToken, setAccessToken } from "../@vars/acessToken";

export const requestConfig = (request: AxiosRequestConfig) => {
  const accessToken = getAccessToken();
  if (accessToken) request.headers["Authorization"] = `Bearer ${accessToken}`;
  return request;
};

export const errorConfig = (error: any) => {
  return Promise.reject(error);
};

export const refreshAuthConfig = async (failedRequest: any): Promise<void> => {
  const { data } = await axios.post("/refresh_token");
  setAccessToken(data.accessToken);
  failedRequest.response.config.headers[
    "Authorization"
  ] = `Bearer ${data.accessToken}`;
};

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.defaults.withCredentials = true;
